<template>
  <div>
    <textarea
        :value="value"
        @input="handleInput"
        :placeholder="__('Elaborate here')"
        rows="12"
        class="w-full p-4 border-2 border-zinc-200 rounded-lg focus:border-primary focus:ring-2 focus:ring-primary transition-colors resize-none"
    ></textarea>
  </div>
</template>

<script setup>
import { __ } from '@/helpers';

const props = defineProps({
  value: {
    type: String,
    default: ''
  },
  placeholder: {
    type: String,
    default: () => __('Type your answer here...')
  }
});

const emit = defineEmits(['input']);

const handleInput = (event) => {
  emit('input', event.target.value);
};
</script>